<template>
  <div class="chat-room">
    <div class="display-flex align-center justify-space-between pt-5 pb-4 px-4">
      <div class="text-poppins-18 text-white">Chat rooms</div>
      <img
        src="../../assets/mobile/icon/arrow-down-white.svg"
        width="27"
        @click="$router.push({ name: 'CommunityMobile' })"
      />
    </div>

    <div class="horizontal-scroll px-4">
      <div v-for="i in 10" :key="i" class="horizontal-scroll__item mr-2 mb-2">
        <div>
          <img src="../../assets/mobile/you.png" width="50" height="50" />
        </div>
      </div>
    </div>

    <div class="px-4">
      <iframe
        width="100%"
        height="315"
        src="https://www.youtube.com/embed/2Te4Dhhy0-U?si=UlNm6BTTXkBUGi7E"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>

    <div class="bg-white chat-room__comment relative">
      <div class="display-flex algin-center justify-space-between mb-2 pa-4">
        <span class="text-poppins-16 font-weight-500 text-black">
          Salva’s room
        </span>
        <span class="text-poppins-13 font-weight-500 text-black">
          36 watching
        </span>
      </div>

      <div v-for="i in 2" :key="i" class="display-flex gap-15 my-3 px-4">
        <img
          src="../../assets/mobile/notification_2.png"
          :width="44"
          :height="44"
          class="rounded"
        />
        <div class="message">
          <div>
            <span class="text-inter-14 text-white font-weight-500">
              Joey •
            </span>
            <span class="text-inter-14 text-white">1m</span>
          </div>
          <div class="text-inter-14 text-white">I’m down! Any ideas??</div>
        </div>
      </div>

      <div class="display-flex align-center gap-10 chat-room__comment--input">
        <img
          src="../../assets/mobile/icon/cricle-add.svg"
          :width="35"
          :height="35"
          class="rounded"
        />
        <input
          type="text"
          class="input-comment full-width pa-2"
          placeholder="Say something!"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.chat-room {
  background: #000;
  min-height: 100vh;
  &__comment {
    border-radius: 10px 10px 0px 0px;
    min-height: 60vh;
    &--input {
      background: #f0f0f0;
      position: absolute;
      bottom: 0px;
      width: 100%;
      padding: 24px 16px;
    }
  }
}

.message {
  border-radius: 6px;
  background: #585fff;
  padding: 8px 12px;
}

.input-comment {
  border-radius: 17.5px;
  border: 1px solid rgba(187, 179, 169, 0.11);
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// chat_room.vue?01a1ce0a